import './App.css';
import MainPage from '../src/pages/main';

function App() {
  return (
    <div className="App">
      <MainPage/>
    </div>
  );
}

export default App;
